var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed top-1/2 left-1/2 m-auto -ml-12 -mt-12 p-5 bg-white bg-opacity-80 h-24 w-24 rounded-lg shadow-xl",staticStyle:{"z-index":"320"}},[_c('v-progress-circular',{staticClass:"mt-3 ml-3",attrs:{"color":_vm.color,"indeterminate":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }